import Vue from "vue";
import VueRouter from "vue-router";
import AppsListing from "../components/Apps.vue";
import AppDetails from "../components/appDetails.vue";
import MainRoute from "../components/shared/MainRoute.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    component: MainRoute,
    meta: {
      title: 'App Catalog',
      public: true, // Allow access to even if not logged in
    },
    data: { title: 'App Catalog' },
    children: [
      {
        path: '/appDetails/:id',
        name: 'appDetails',
        component: AppDetails,
        props: true,
        meta: {
          title: 'App Catalog | App Details',
          public: true
        }
      },
      {
        path: '/',
        name: 'appsListing',
        component: AppsListing
      }
    ]
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'App Catalog'
  next()
})

export default router;
